<ng-container *transloco="let t">
  <div>
    <div><label>{{label}}</label></div>
    <div class="row" [formGroup]="form">
      <!-- years -->
      <div class="col-2">
        <mat-form-field class="w-100" appearance="fill">
          <mat-label for="years">{{t('common.years')}}</mat-label>
          <input matInput formControlName="years" type="number" name="years" />
        </mat-form-field>
      </div>
      <!-- months -->
      <div class="col-2">
        <mat-form-field class="w-100" appearance="fill">
          <mat-label for="months">{{t('common.months')}}</mat-label>
          <input matInput formControlName="months" type="number" name="months" />
        </mat-form-field>
      </div>
      <!-- days -->
      <div class="col-2">
        <mat-form-field class="w-100" appearance="fill">
          <mat-label for="days">{{t('common.days')}}</mat-label>
          <input matInput formControlName="days" type="number" name="days" />
        </mat-form-field>
      </div>
      <!-- hours -->
      <div class="col-2">
        <mat-form-field class="w-100" appearance="fill">
          <mat-label for="hours">{{t('common.hours')}}</mat-label>
          <input matInput formControlName="hours" type="number" name="hours" />
        </mat-form-field>
      </div>
      <!-- minutes -->
      <div class="col-2">
        <mat-form-field class="w-100" appearance="fill">
          <mat-label for="minutes">{{t('common.minutes')}}</mat-label>
          <input matInput formControlName="minutes" type="number" name="minutes" />
        </mat-form-field>
      </div>
      <!-- seconds -->
      <div class="col-2">
        <mat-form-field class="w-100" appearance="fill">
          <mat-label for="seconds">{{t('common.seconds')}}</mat-label>
          <input matInput formControlName="seconds" type="number" name="seconds" />
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-container>
